<template>
  <div class="answer-confirm" v-show="visible">
    <div class="answer-confirm-content">
      <div class="close" @click="handleClose" v-if="isActiveSubmission"></div>
      <h2 class="content_header">{{title}}</h2>
      <div id="answer" class="content__text">
        <div class="content__text_legend">
          <span class="legend-item answer">已作答</span>
          <span class="legend-item">未作答</span>
        </div>
        <div class="content__text_bandle">
          <ul class="bandle_list">
            <li 
            v-for="(item,index) in bundleList" 
            :key="index"
            :class="statusClass(item)"
            class="bandle_list__item"
            >
            <span>第{{index + 1}}题</span>
            <span>{{item.score}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="answer-confirm__footer">
        <template v-if="isActiveSubmission">
          <div class='hand_btn'>
            <div
            class="answer-confirm__footer_btn back"
            @click="handleClose"
          >还要修改</div>
          <div
            class="answer-confirm__footer_btn submit"
            @click="handleHandSubmit"
          >确认提交</div>
        </div>
        </template>
        <template v-else>
          <div
            class="answer-confirm__footer_btn submit"
            @click="handleBack"
          >好的</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'answerConfirm',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    bundleList:{
      type:Array,
      default:()=>{}
    },
    isActiveSubmission:{ //isActiveSubmission: false 自动提交（老师收题）true 学生手动交卷
      type: Boolean,
      default: false,
    },
    totalScore:{
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: 0,
    }
  },
  data(){
    return{
      
    }
  },
  computed: {
    title(){
      let txt = ''
      if(this.isActiveSubmission){
       txt = this.totalScore ? `题目状态(本卷得分：${this.totalScore})` : '题目状态'
      }else{
        txt = this.totalScore ? `提交成功(本卷得分：${this.totalScore})` : '提交成功'
      }
      return txt;
    }
  },
  methods: {
    statusClass({
      finish
    }) {
      if (finish) return `bandle_list__item-resolve`
    },
    handleClose() {
      this.$emit('update:visible',false);
    },
    async handleHandSubmit(){
      await this.$emit('handleHandSubmit')
      await this.$emit('update:visible',false);
    },
    handleBack(){
      this.$emit('handleBack')
    },
  },
};
</script>

<style lang="less" scoped>
.answer-confirm {
  position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left:0;
	z-index: 999;
	background-color:rgba(12,12,12,.616);
  color: #333;
  cursor: default;
  &-content{
    width: 700px;
    // height: 400px;
    padding-top:25px;
    box-sizing: border-box;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    border-radius:10px;
  }

  .content__text{
    padding:0 34px 0 46px;
    margin-right:12px;
    max-height: 310px;
    min-height: 250px;
    overflow: auto;
    margin-bottom: 98px;
    &_legend{
      display: flex;
      padding-left: 20px;
      padding-bottom: 16px;
    }
    .legend-item{
      display: flex;
      align-items: center;
      font-size: 14px;
      color:#333;
      &::before{
        content:'';
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #BDBDBD;
        margin-right:2px;
      }
      &.answer{
        margin-right: 20px;
        &::before{
          background: #83A220;
        }
      }
    }
    &_bandle{
      .bandle_list{
        display: flex;
        padding: 0;
        margin: 0;
        list-style: none;
        flex-wrap: wrap;
        &__item{
          width: 80px;
          height: 80px;
          background: #D8D8D8;
          border: 1px solid #BDBDBD;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          margin: 10px 20px;
          font-size: 16px;
          color: #000;
          &-resolve {
            background:rgba(170,197,84,1);
            border:2px solid rgba(131,162,32,1);
        }
        }
      }
    }
    &::-webkit-scrollbar {
      display: block;
      width: 8px;
      height: 268px;
    } /* 整体样式 */
    ::-webkit-scrollbar-track {
      background-color: rgba(255,255,255,.5);  //设置背景透明

    } /* 轨道 */
    &::-webkit-scrollbar-thumb {
     width:4px;
     height: 268px;
     border-radius:5px;
     background-color: #999;  //设置背景透明
    } /* 滑块 */
    &::-webkit-scrollbar-track-piece {
      background-color: none;
    } /* 不包含滑块的轨道区 */
    #answer {
      height: 268px;
      overflow-y: overlay;
      padding-right: 5px;
    }
  }
  .content_header{
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color:#000;
    padding: 0;
    margin: 0;
    padding-bottom: 20px;
  }
  .answer-confirm__footer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding:30px 0;
    width: 100%;
    box-shadow: 0px 0px 8px 0px rgba(153, 153, 153, 0.2);
    position: absolute;
    bottom:0;
    left: 0;
    .hand_btn{
      display: flex;
    }
    .answer-confirm__footer_btn{
      width: 110px;
      height: 38px;
      text-align: center;
      line-height: 36px;
      border-radius: 20px;
      cursor: pointer;
      &.back{
        background: #FFF7E7;
        color:#6B4C2E;
        margin-right:64px;
        border: 1px solid #FCEBCB;
      }
      &.submit{
        background: #68953C;
        color:#F6F2DA;
        border: 1px solid #4B7635;
      }
      &.ok{
        background: #68953C;
        color:#F6F2DA;
        border: 1px solid #4B7635;
      }
    }
  }
}
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18px;
  height: 18px;
  background: url('../assets/competition_close.png') no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
</style>
